import React from 'react'
import { useQuery } from 'react-query'
import { useSelector } from 'react-redux'
import { Notification } from '@offerzen/pinata-shame'

import { getCurrentCandidate } from '@/CandidateExperience/selectors/candidate'

import ApplicationCard from '../ApplicationCard'

import SkeletonList from './SkeletonList'
import EmptyListCard from './EmptyListCard'
import { fetchCandidateApplications } from './api'
import styles from './styles'

const ApplicationList = () => {
  const { id: currentCandidateProfileId } = useSelector(getCurrentCandidate)
  const { data, isLoading, isError } = useQuery(['candidateApplications', currentCandidateProfileId], () =>
    fetchCandidateApplications(currentCandidateProfileId),
  )

  if (isError) {
    return (
      <Notification theme="error">
        <div role="alert">Something went wrong.</div>
      </Notification>
    )
  }

  if (isLoading || !data) return <SkeletonList />

  const { candidateProfile: { applications } = {} } = data

  if (applications?.nodes?.length === 0) return <EmptyListCard />

  return (
    <ul className={styles.list}>
      <For each="application" of={applications.nodes}>
        <li key={application.id}>
          <ApplicationCard application={application} />
        </li>
      </For>
    </ul>
  )
}

export default ApplicationList
